<template>
  <ul class="layout-menu">
    <template v-for="(item, i) in model" :key="item">
      <app-menu-item v-if="!item.separator" :item="item" :index="i"></app-menu-item>
      <li v-if="item.separator" class="menu-separator"></li>
    </template>
  </ul>
</template>

<script setup>
import { ref } from 'vue';

import AppMenuItem from './AppMenuItem.vue';
const userPermissions = JSON.parse(localStorage.getItem('user_permissions')) || [];
const rawModel = ref([
  {
    label: '',
    items: [
      {
        label: 'داشبورد',
        icon: 'home',
        to: '/',
        permission: 'dashboard'
      }
    ]
  },
  {
    label: '',
    icon: 'gear',
    items: [
      {
        label: 'سفارشات',
        icon: 'cart-shopping',
        items: [
          {
            label: 'لیست سفارشات',
            icon: 'layer-group',
            to: { name: 'Orders' },
            permission: 'orders'
          },
          {
            label: 'سفارشات ویژه',
            icon: 'layer-group',
            to: { name: 'SpecialOrder' },
            permission: 'special-orders'
          },
          {
            label: 'سفارشات مرجوعی',
            icon: 'layer-group',
            to: { name: 'ReturningItems' },
            permission: 'returning-items'
          }
        ]
      },
      {
        label: 'مدیریت محصولات',
        icon: 'gem',
        items: [
          {
            label: 'لیست محصولات',
            icon: 'gem',
            to: { name: 'Product' },
            permission: 'product'
          },
          {
            label: 'جنس محصول - مظنه لحظه ای',
            icon: 'gem',
            to: { name: 'ProductType' },
            permission: 'product-type'
          },

          {
            label: 'محصولات تخفیف دار',
            icon: 'percentage',
            to: { name: 'DiscountProductList' },
            permission: 'discount-product-items'
          },
          {
            label: 'بن های تخفیف',
            icon: 'percent',
            to: { name: 'Discounts' },
            permission: 'discounts'
          },
          {
            label: 'موجودی محصولات انبار',
            icon: 'gem',
            to: { name: 'ProductItems' },
            permission: 'product-items'
          },
          {
            label: 'گزارش انبار',
            icon: 'gem',
            to: { name: 'Report' },
            permission: 'report'
          },
          {
            label: 'تجهیزات',
            icon: 'cubes',
            to: { name: 'Equipment' },
            permission: 'equipment'
          },
          {
            label: 'فرمول اجرت',
            icon: 'calculator',
            to: { name: 'Wages' },
            permission: 'wages'
          },
          {
            label: 'دسته بندی محصولات',
            icon: 'layer-group',
            to: { name: 'ProductCategory' },
            permission: 'product-category'
          },

          {
            label: 'کارت های هدیه',
            icon: 'gift',
            to: { name: 'GiftCards' },
            permission: 'gift-cards'
          },
          {
            label: 'رنگ ها',
            icon: 'droplet',
            to: { name: 'Colors' },
            permission: 'colors'
          },
          {
            label: 'تنوع مشتریان',
            icon: 'person-half-dress',
            to: { name: 'ProductUsage' },
            permission: 'product-usage'
          },

          {
            label: 'عیار ها',
            icon: 'gem',
            to: { name: 'Karat' },
            permission: 'karat'
          },
          {
            label: 'برند ها',
            icon: 'copyright',
            to: { name: 'Brands' },
            permission: 'brands'
          },
          {
            label: 'گارانتی ها',
            icon: 'award',
            to: { name: 'Warranty' },
            permission: 'warranty'
          }
        ]
      },
      {
        label: 'مدیریت محتوا',
        icon: 'newspaper',
        items: [
          {
            label: 'لیست مقالات',
            icon: 'newspaper',
            to: { name: 'Article', query: { type: 'article' } },
            permission: 'article'
          },
          {
            label: 'لیست اخبار',
            icon: 'newspaper',
            to: { name: 'NewsArticle', query: { type: 'news' } },
            permission: 'news-article'
          },
          {
            label: 'لیست صفحات',
            icon: 'newspaper',
            to: { name: 'PageArticle', query: { type: 'page' } },
            permission: 'page-article'
          },
          {
            label: 'دسته بندی مقالات',
            icon: 'layer-group',
            to: { name: 'ArticleCategory', query: { type: 'article' } },
            permission: 'article-category'
          },
          {
            label: 'دسته بندی اخبار',
            icon: 'layer-group',
            to: { name: 'ArticleCategory', query: { type: 'news' } },
            permission: 'news-category'
          },
          {
            label: 'دسته بندی صفحات',
            icon: 'layer-group',
            to: { name: 'ArticleCategory', query: { type: 'page' } },
            permission: 'page-category'
          }
        ]
      },
      {
        label: 'تنظیمات پایه',
        icon: 'gear',
        items: [
          {
            label: 'تنظیمات اصلی',
            icon: 'gear',
            to: '/settings',
            permission: 'settings'
          },
          {
            label: 'لیست مشتریان',
            icon: 'users',
            to: '/customers',
            permission: 'customers'
          },
          {
            label: 'تاریخچه بروزرسانی',
            icon: 'gear',
            to: '/price-history',
            permission: 'price-history'
          },
          {
            label: 'مدیران',
            icon: 'users',
            to: '/admins',
            permission: 'admins'
          },
          {
            label: 'سطوح دسترسی',
            icon: 'users',
            to: '/roles',
            permission: 'roles'
          },
          {
            label: 'پیام انبوه',
            icon: 'bullhorn',
            to: { name: 'Notification' },
            permission: 'notification'
          },
          {
            label: 'کشور ها',
            icon: 'earth-asia',
            to: '/countries',
            permission: 'countries'
          },
          {
            label: 'شهر ها',
            icon: 'city',
            to: '/cities',
            permission: 'cities'
          },
          {
            label: 'روز های تعطیل',
            icon: 'calendar',
            to: { name: 'OffDays' },
            permission: 'off-days'
          },
          {
            label: 'اسلایدر ها',
            icon: 'images',
            to: { name: 'Slider' },
            permission: 'slider'
          },
          {
            label: 'بنر ها',
            icon: 'images',
            to: { name: 'Banner' },
            permission: 'banner'
          },
          {
            label: 'شیوه های حمل',
            icon: 'truck-pickup',
            to: { name: 'Shipment' },
            permission: 'shipment'
          },
          {
            label: 'شیوه های پرداخت',
            icon: 'truck-pickup',
            to: { name: 'PaymentMethod' },
            permission: 'payment-methods'
          },
          {
            label: 'تنظیمات مهربن',
            icon: 'gift',
            to: { name: 'MehrBonSetting' },
            permission: 'mehr-bon-setting'
          }
        ]
      },
      {
        label: 'مدیریت تیکت',
        icon: 'life-ring',
        items: [
          {
            label: 'مدیریت تیکت',
            icon: 'layer-group',
            to: { name: 'Ticket' },
            permission: 'ticket'
          },
          {
            label: 'مدیریت نظرات',
            icon: 'comments',
            to: { name: 'Comments' },
            permission: 'comments'
          },
          {
            label: 'مدیریت تماس ها',
            icon: 'phone',
            to: { name: 'Contacts' },
            permission: 'contacts'
          },
          {
            label: 'دپارتمان تیکت ها',
            icon: 'layer-group',
            to: { name: 'TicketDepartment' },
            permission: 'ticket-department'
          }
        ]
      }
    ]
  }
]);
function filterMenuByPermissions(menuRef, userPermissions) {
  const menu = Array.isArray(menuRef) ? menuRef : menuRef.value;
  if (!Array.isArray(menu)) {
    console.error('⛔️ menu is not an array:', menu);
    return [];
  }

  return menu
    .map((item) => {
      if (item.items) {
        const filteredChildren = filterMenuByPermissions(item.items, userPermissions);
        if (filteredChildren.length > 0) {
          return {
            ...item,
            items: filteredChildren
          };
        }
      }

      if (!item.items && (!item.permission || userPermissions.includes(item.permission))) {
        return item;
      }

      return null;
    })
    .filter(Boolean);
}

// فیلتر نهایی منو
const model = ref(filterMenuByPermissions(rawModel, userPermissions));
</script>

<style lang="scss" scoped></style>
